import React from 'react'
import Classes from "classnames";
import stopPropagation from '../../../gd/utils/stop-propagation';
import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top";
import ItemViewLayout from "../../../../app/item-view/common/layout/layout";
import ModalV4 from "../../../../app/ui/modal/v4/v4";
import ModalNewTimeReport_Form from "./form";
import Task from "../../../model2/task/task";
import Timer from "../../../gd/task-timer/timer";


export type ModalCreateTimeReportProps = {
    timer?              : Timer,

    task                : Task,
    minDate?            : Moment,
    date?               : Moment,
    callback?           : callback,
    userId?             : ID,
    taskMessageId?      : ID,

    needMyTimeResponse? : boolean,
    reportedTimeMinutes?: number,
    startMoment?        : Moment,
    endMoment?          : Moment,
}

type Props = {
    className?  : string,
    params      : ModalCreateTimeReportProps
}

export default class ModalCreateTimeReport extends ModalV4 {

    constructor(props: Props) {
        super(props);
    }

    render() {

        const modalClasses = Classes('ui5-iv iv-time-report',{
        });

        return (
            <div className={modalClasses} onClick={stopPropagation}>


                <ItemViewTop title="Time Report" onCloseClick={this.closeModal}/>

                <div className="iv-left-column">
                    <div className="details-big-icon">
                        <div className={Classes("svg-icon", "s54", "time")}/>
                    </div>

                </div>

                <ModalNewTimeReport_Form params={this.props.params} callback={this.props.params.callback} />


            </div>
        )

    }


}
